import * as React from 'react';
import { useEffect } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ApplicationState } from '../../store';
import { Container, Row, Col, Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';

import * as CheckoutStore from '../../store/Checkout';
import * as CartStore from '../../store/Cart';
import * as PartnerCheckoutStore from '../../store/PartnerCheckout';
import * as AuthorizationStore from '../../store/Authorization';

import ImpactPartnerService from '../../services/ImpactPartnerService';

import { ImpactPartner } from "../../models/ImpactPartner";
import { ShoppingCartItem } from '../../models/ShoppingCart';

import CheckoutWizard from './CheckoutWizard';
import CheckoutPartnerStep from './CheckoutPartnerStep';
import { OrderResponseDto } from '../../models/OrderResponseDto';

function CheckoutPage(props: {
    checkoutState: CheckoutStore.IState,
    checkoutActions: typeof CheckoutStore.actionCreators,
    cartState: CartStore.IState;
    cartActions: typeof CartStore.actionCreators;
    partnerCheckoutState: PartnerCheckoutStore.IState,
    partnerCheckoutActions: typeof PartnerCheckoutStore.actionCreators,
    authorization: AuthorizationStore.IState
}) {

    const [checkoutReady, setCheckoutReady] = React.useState(false);
    const history = useHistory();

    useEffect(() => {
        props.checkoutActions.setShoppinCart(props.cartState.cartToCheckout);
        const cart = props.cartState.cartToCheckout;
        if (cart) {
            ImpactPartnerService.list().then(response => {

                if (!response.hasErrors) {
                    const partnerIds = cart.Items.map(item => item.PartnerId);

                    const partners = response.value.filter(x => (partnerIds.indexOf(x.Id)) > -1)

                    props.checkoutActions.setAvailableImpactPartners(partners);
                    props.checkoutActions.setImpactPartner(partners[0]);
                    setCheckoutReady(true);
                }
            });
        }

        ImpactPartnerService.getPartnersMessages().then(response => {
            if (!response.hasErrors) {
                props.checkoutActions.setImpactPartnersMessages(response.value);
            }
        })
    }, []);

    useEffect(() => {
        const canRemoveProcessedPartner = props.partnerCheckoutState.customerOrderNumber
            || (props.partnerCheckoutState.impactPartnerProcessed &&
                !props.partnerCheckoutState.customerOrderNumber
                && !props.partnerCheckoutState.hasErrorOnSubmit);

        if (canRemoveProcessedPartner) {
            removeProcessedPartner(props.checkoutState.currentImpactPartner);
        }

    }, [props.partnerCheckoutState.customerOrderNumber, props.partnerCheckoutState.impactPartnerProcessed])

    useEffect(() => {
        if (props.checkoutState.currentShoppingCart
            && props.checkoutState.processedImpactPartners.length === 0
            && checkoutReady) {
            props.cartActions.markCartProcessed(props.checkoutState.currentShoppingCart.CartId);
            setCheckoutReady(false);
        }

    }, [props.checkoutState.processedImpactPartners, checkoutReady])

    const removeProcessedPartner = (partner: ImpactPartner) => {

        props.checkoutActions.setProcessedImpactPartner(partner);
    }

    const getCartItems = (partner: ImpactPartner) => {
        let cartItems: ShoppingCartItem[] = [];

        if (props.checkoutState.currentShoppingCart) {
            const items = props.checkoutState.currentShoppingCart.GroupInner[partner.FormatedName];
            cartItems = items.filter(x => x.Available);
        }

        return cartItems || [];
    }

    const stepsData = () => {
        let data = props.checkoutState.availableImpactPartners.map((partner, index) => {
            const items = getCartItems(partner);
            props.partnerCheckoutState.items = items.slice();

            const nextPartner = index < props.checkoutState.availableImpactPartners.length - 1 ? props.checkoutState.availableImpactPartners[index + 1] : undefined;

            return (componentProps: any) => <CheckoutPartnerStep
                cartId={props.checkoutState.currentShoppingCart.CartId}
                cartName={props.checkoutState.currentShoppingCart.CartName + " Checkout"}
                key={partner.Id}
                partner={partner}
                currentImpactPartner={props.checkoutState.currentImpactPartner}
                partnersMessages={props.checkoutState.impactPartnersMessages}
                cartItems={items}
                partnerCheckout={props.partnerCheckoutState}
                partnerCheckoutActions={props.partnerCheckoutActions}
                nextPartner={nextPartner}
                {...componentProps} />
        });

        return data;
    }

    const toCart = () => {
        props.partnerCheckoutActions.resetState();
        history.push("/cart");
    }

    const sendSummaryOrderResponse = () => {
        const orderResponse: OrderResponseDto = {
            userId: props.authorization.currentUser.UserId,
            cartId: props.checkoutState.currentShoppingCart.CartId,
            cartName: props.checkoutState.currentShoppingCart.CartName,
            partners: props.partnerCheckoutState.partnerResults
        }

        props.checkoutActions.sendOrderResponse(orderResponse);
    }

    return (<Container fluid className="checkout-page">
        {!props.checkoutState.currentShoppingCart &&
            <Row>
                <Col>
                    <div className="navigation back-to-cart">
                        <Button color="link" className="d-inline-block" onClick={toCart}>Back to Cart</Button>
                    </div>
                </Col>
            </Row>}
        {props.checkoutState.currentShoppingCart && props.checkoutState.availableImpactPartners.length > 0 &&
            <CheckoutWizard
                stepsData={stepsData()}
                onCurrentStepChanged={(step) => { props.checkoutActions.setImpactPartner(props.checkoutState.availableImpactPartners[step]); }}
                sendSummaryOrderResponse={sendSummaryOrderResponse}
                sendingOrderResponse={props.checkoutState.sendingOrderResponse}
            />
        }
    </Container>);
}

export default connect((state: ApplicationState) => ({
    checkoutState: state.checkout,
    cartState: state.cart,
    partnerCheckoutState: state.partnerCheckout,
    authorization: state.authorization
}),
    (dispatch, getState) => ({
        cartActions: bindActionCreators(CartStore.actionCreators, dispatch),
        checkoutActions: bindActionCreators(CheckoutStore.actionCreators, dispatch),
        partnerCheckoutActions: bindActionCreators(PartnerCheckoutStore.actionCreators, dispatch)
    }))(CheckoutPage);